import {StorageUtil} from '../../../common/Auth.js';
import {api} from '../../../common/config.js';
import {store} from '../../../store/store.js';

store.message = {
    _this: null,
    navName: '逾期消息',
}
export default {
    name: "message",
    data() {
        store.message._this = this;
        return {
            ...store.message,
        }
    },
    computed: {
        beOverdueNum() {
            return store.wrap.messageCount
        },
        otherNum() {
            return store.wrap.unreadCount
        }
    },
    mounted() {
        store.personal._this.activeNav = "我的消息";
        //未读逾期消息
        var user = StorageUtil.getObject("user");
        var url = api.personalnews.overdue.replace('{idCard}', user.idCard);
        /*ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
          _this.beOverdueNum= data.messageCount
        }, (result) => { }, this)
        //获取其他消息数量
        ajaxUtil.ajaxJson(api.personalnews.getUnreadcount, {readerId: user.readerId}, 'POST', (data) => {
          _this.otherNum= data.unreadCount
        }, (result) => {}, this)*/
    },
}